import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import InputError from '@/components/form/base/InputError.tsx';
import InputHint from '@/components/form/base/InputHint.tsx';
import { cn } from '@/lib/utils.ts';
import { clsx } from 'clsx';

/**
 * `toolbar` istnieje dla panelu filtrów tabeli — tam wszystko chodzi na
 * 30 px / 12 px. Formularze zostają na `default`.
 */
export type ValueInputSize = 'default' | 'toolbar';

const sizeClasses: Record<ValueInputSize, { wrapper: string; text: string }> = {
  default: { wrapper: 'px-3 py-1.5', text: 'text-sm' },
  toolbar: { wrapper: 'px-2 py-1.5', text: 'text-xs' },
};

export const ValueInput = ({
  label,
  register,
  placeholder,
  required = false,
  disabled = false,
  error,
  hint,
  sufix,
  type = 'text',
  step,
  inputClassName,
  size = 'default',
}: {
  label?: string;
  register: UseFormRegisterReturn;
  placeholder: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  hint?: string;
  sufix?: string;
  type?: 'text' | 'number';
  step?: number | 'any';
  inputClassName?: string;
  size?: ValueInputSize;
}) => {
  const inputRef = React.useRef<HTMLInputElement | null>(null);
  const sizing = sizeClasses[size];

  return (
    <div className="flex w-full flex-col items-start gap-1.5">
      {label && (
        <InputLabel label={label} required={required} disabled={disabled} />
      )}
      <div
        onClick={() => inputRef?.current?.focus()}
        className={cn(
          'flex w-full cursor-text flex-row flex-nowrap items-center gap-2 rounded-md border bg-basic-white',
          sizing.wrapper,
          {
            'cursor-default bg-basic-disabled-bg': disabled,
            'border-neutral-200': !error,
            'border-error-100': error,
          },
        )}
      >
        <input
          type={type}
          step={step}
          placeholder={placeholder}
          className={clsx(
            'w-full text-base-text transition-colors',
            sizing.text,
            {
              'placeholder-neutral-300': !disabled,
              'bg-basic-disabled-bg text-neutral-500 placeholder-basic-disabled-main':
                disabled,
            },
            inputClassName,
          )}
          disabled={disabled}
          {...register}
          ref={(element) => {
            register.ref(element);
            inputRef.current = element;
          }}
        />
        {sufix && (
          <span
            className={clsx(
              'w-full truncate text-right text-neutral-300',
              sizing.text,
            )}
          >
            {sufix}
          </span>
        )}
      </div>
      <InputError error={error} />
      <InputHint hint={hint} />
    </div>
  );
};
